/**
 * Centralized version configuration
 * Single source of truth for app version and fallback values
 *
 * Update CURRENT_VERSION here when releasing - no need to restart dev server!
 */

export const VERSION_CONFIG = {
  // Current app version - update this when releasing new versions
  CURRENT_VERSION: "0.1.7.7",

  // Fallback minimum version if remote config fails
  FALLBACK_MINIMUM_VERSION: "0.1.7.0",

  // Remote config keys
  REMOTE_CONFIG_KEYS: {
    MINIMUM_VERSION: "web_minimumAppVersion",
    FORCE_UPDATE: "web_forceUpdate",
  },

  // LocalStorage keys
  STORAGE_KEYS: {
    BYPASS: "mira_version_check_bypass",
  },
};
